import React, {useEffect, useState, useContext} from 'react';
import {Popover, Button, message} from 'antd';
import {AxiosRequestWithImba} from "../../helpers/AxiosRequest";
import {RoleContext} from "../../contexts/RoleContext";
import {DeleteContext} from "../../contexts/DeleteContext";


const Complete = ({record, imba_id}) => {
    const {getDelete} = useContext(DeleteContext);
    const {setDelete} = useContext(DeleteContext);
    const deleted = getDelete()
    const [visible, setVisible] = useState(false);

    const success = (text) => {
        message.success(text);
    };

    const onDelete = (item) => {
        AxiosRequestWithImba('delete_regex', {
            regexId: record.id,
        }, imba_id).then((data) => {
            if (!data.error)
            {
                deleted = getDelete()
                if (deleted==0) setDelete(1);
                else setDelete(0);
                success('Successfully deleted!')
                setVisible(false)
            }
        })
    }

    const handleVisibleChange = (visible) => {
        setVisible(visible)
    };

    const content = (
        <div>
            <Button className={'m-1'} onClick={() => onDelete(record)}>OK</Button>
        </div>
    );
    const {getRole} = useContext(RoleContext);
    const role = getRole()


    if(role !='operator'){
    return (
        <Popover visible={visible} placement="topLeft" title={'Confirm delete'} content={content} trigger={'click'} onVisibleChange={handleVisibleChange}>
            <a className={'button'} style={{ margin: '0 8px' }} id={`ban-${record.id}`}>Delete</a>
        </Popover>
    );
    }
    else{
        return (
            <>
            </>
        );
    }
};


export default Complete;